import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_2 = { class: "row align-middle" };
const _hoisted_3 = { class: "col-sm-5 col-12 text-end pl-0 d-flex flex-row" };
const _hoisted_4 = { class: "col-sm-4 col-12 text-end pl-0 d-flex flex-row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_checkbox_field = _resolveComponent("g-checkbox-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$appHost.pageMeta.title,
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_g_text_field, {
                "data-object": _ctx.$data,
                "data-member": "codeConfirmed",
                "data-mode": "model",
                "max-length": 6,
                label: _ctx.$t('account.ActivationCodeWithNotes'),
                mode: "text",
                "show-clear-button": false,
                onEnterKey: _ctx.execute
            }, null, 8, ["data-object", "label", "onEnterKey"]),
            _createVNode(_component_g_checkbox_field, {
                "data-object": _ctx.$data,
                "data-member": "remember",
                "data-mode": "model",
                mode: "text"
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('account.RememberDevice')), 1)
                ]),
                _: 1
            }, 8, ["data-object"]),
            (_ctx.hasError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-sm-3 my-auto align-middle pr-0 d-flex justify-content-sm-star" }, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$t('account.Command.CodeResend'),
                        type: "normal",
                        "button-style": "btn-outline-secondary",
                        onClick: _ctx.resendCode,
                        "is-loading": _ctx.isSending
                    }, null, 8, ["text", "onClick", "is-loading"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$t('account.Activation.Confirm'),
                        onClick: _withModifiers(_ctx.execute, ["stop", "prevent"]),
                        disabled: _ctx.disableLogin,
                        "is-loading": _ctx.isLoading,
                        type: "submit"
                    }, null, 8, ["text", "onClick", "disabled", "is-loading"])
                ])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
